import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Annual from "../pages/annual/page";
import Monthly from "../pages/monthly/page";
import RankDetail from "../pages/detail/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/annual",
    element: <Annual />,
  },
  {
    path: "/monthly",
    element: <Monthly />,
  },
  {
    path: "/rank/:id",
    element: <RankDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;